import { FC, memo } from 'react'
import styles from './index.module.scss'

interface CoinLogoProps {
  logo?: string
  networkLogo?: string
}

const CoinLogo: FC<CoinLogoProps> = ({ logo, networkLogo }) => {
  if (!logo) {
    return null
  }
  return (
    <div className={styles.container} style={{ backgroundImage: `url(${logo})` }}>
      {networkLogo && <img src={networkLogo} alt="" />}
    </div>
  )
}

export default memo(CoinLogo)
